export default __webpack_public_path__ + "static/media/madeWithThunkNotes_lightmode.f2f753e6.svg";